import React, { useCallback } from 'react';
import { useStore } from '../../../../../store/rootStore';
import moment from 'moment';
import { Divider } from 'antd';
import blankProfilePicture from "../../../../../assets/avatars/blankProfilePicture.png";
import { getDirection } from '../../../../../helpers';
import classnames from 'classnames';
import styles from './MessagesListNote.module.scss';
const MessagesListNote = ({ note, isHighlighted }) => {
    const { agentsStore, chatNotesStore } = useStore();
    const dir = getDirection();
    const getAgent = useCallback((note) => {
        const agent = agentsStore.usersMap.get(note.createdBy);
        return agent || null;
    }, [agentsStore.usersMap]);
    const onClick = useCallback(() => {
        chatNotesStore.setSelectedNoteId(note._id.toString());
    }, [note]);
    const agent = getAgent(note);
    return (React.createElement(Divider, { className: classnames(styles.wrapper, { [styles.highlighted]: isHighlighted }) },
        React.createElement("div", { className: styles.noteContainer, onClick: onClick, dir: dir },
            React.createElement("div", { className: styles.noteHeader },
                React.createElement("div", { dir: dir, className: styles.noteText },
                    "\"",
                    note.text,
                    "\"")),
            React.createElement("div", { className: styles.noteBody },
                React.createElement("img", { src: blankProfilePicture, className: styles.chatNoteAvatar, alt: "Agent avatar" }),
                React.createElement("div", { className: styles.noteContent },
                    React.createElement("div", { dir: dir, className: styles.noteAgentName }, (agent === null || agent === void 0 ? void 0 : agent.displayName) || (agent === null || agent === void 0 ? void 0 : agent.email) || ''),
                    React.createElement("div", { dir: dir, className: styles.noteDate }, moment(note.createdAt).format('LLL')))))));
};
export default MessagesListNote;
